<template>
  <discount-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processDiscountForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateDiscount } from '@/services/discount.service'
import discountBlankForm from '@/components/forms/discount/DiscountBlankForm'

export default {
  name: 'discount-edit-form',
  components: { discountBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        discount: {
          id: [],
          name: [],
          amount: [],
          start_date: [],
          end_date: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processDiscountForm () {
      this.updateDiscount().then((success) => {
        if (success) {
          this.showMsg('Информация была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateDiscount () {
      return updateDiscount(this.$attrs.discount).then((response) => {
        this.fillErrors(this.errors.discount, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.discount, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DiscountEditForm.vue?d993195e